module.exports = __webpack_public_path__ + "static/media/brandLoyalty_lg-desktop.91615a99.png";